export function filterPrice(price: string) {
    if (!price) return;
    const replacePrice = price.slice(3);
    return parseFloat(replacePrice);
}